<template>
  <div class="vanilla-e-wrap">
    <main class="screen" role="main" aria-labelledby="question-heading">

      <div class="header">
        <button
          type="button"
          class="back-button"
          disabled
          aria-label="Zurück"
        >←</button>
        <span class="question-counter">Frage 45 von 67</span>
      </div>

      <div
        class="progress-bar"
        role="progressbar"
        aria-valuenow="45"
        aria-valuemin="1"
        aria-valuemax="67"
        aria-label="Fortschritt"
      >
        <div class="progress-segment" style="flex: 18;">
          <div class="progress-segment-fill" style="width: 100%;"></div>
        </div>
        <div class="progress-segment" style="flex: 10;">
          <div class="progress-segment-fill" style="width: 100%;"></div>
        </div>
        <div class="progress-segment" style="flex: 8;">
          <div class="progress-segment-fill" style="width: 100%;"></div>
        </div>
        <div class="progress-segment" style="flex: 8;">
          <div class="progress-segment-fill" style="width: 100%;"></div>
        </div>
        <div class="progress-segment" style="flex: 10;">
          <div class="progress-segment-fill" style="width: 10%;"></div>
        </div>
        <div class="progress-segment" style="flex: 10;"></div>
        <div class="progress-segment" style="flex: 3;"></div>
      </div>

      <div class="question-block">
        <p class="section-label">{{ question.sectionLabel }}</p>
        <h1 id="question-heading" class="question-title">{{ question.title }}</h1>
        <p class="question-prompt">{{ question.prompt }}</p>
      </div>

      <button
        type="button"
        class="tooltip-button"
        :aria-expanded="String(tooltipOpen)"
        aria-controls="tooltip-q45"
        @click="tooltipOpen = !tooltipOpen"
      >
        <span class="tooltip-icon" aria-hidden="true">i</span>
        {{ question.tooltipButtonLabel }}
      </button>

      <div
        v-if="tooltipOpen"
        id="tooltip-q45"
        class="tooltip-content"
      >
        {{ question.tooltip }}
      </div>

      <fieldset class="answer-fieldset">
        <legend class="sr-only">Antwortoptionen</legend>
        <label
          v-for="opt in question.options"
          :key="opt.value"
          class="answer-option"
        >
          <input
            type="radio"
            name="q45"
            :value="opt.value"
            v-model="selected"
          >
          <span class="answer-content">
            <span class="answer-label">{{ opt.label }}</span>
            <span v-if="opt.detail" class="answer-detail">{{ opt.detail }}</span>
          </span>
        </label>
      </fieldset>

      <div class="footer">
        <button
          type="button"
          class="next-button"
          :disabled="!selected"
          @click="goNext"
        >Weiter</button>
      </div>

    </main>
  </div>
</template>

<script>
export default {
  name: 'VanillaE',
  data() {
    return {
      tooltipOpen: false,
      selected: null,
      question: {
        sectionLabel: 'Getreide',
        title: 'Welche Art von Brot isst du normalerweise?',
        prompt: 'Wähle die Sorte, die du am häufigsten konsumierst.',
        tooltipButtonLabel: 'Beispiele anzeigen',
        tooltip:
          'Vollkornbrot = pain complet = pane integrale. Ruchbrot = pain bis = pane bigio. Bei Mischungen: wähle die Sorte, die du am häufigsten isst.',
        options: [
          { value: 'weiss', label: 'Weissbrot', detail: 'z.B. Tessinerbrot, Zopf, Baguette' },
          { value: 'ruch', label: 'Ruchbrot oder Halbweissbrot', detail: 'z.B. Pariser, Bürli' },
          { value: 'vollkorn', label: 'Vollkornbrot', detail: 'aus Vollkornmehl, oft mit ganzen Körnern' },
          { value: 'dunkel', label: 'Dunkles Brot', detail: 'z.B. Roggenbrot, Sauerteigbrot' },
          { value: 'kein', label: 'Ich esse kein Brot' },
        ],
      },
    };
  },
  methods: {
    goNext() {
      if (!this.selected) return;
      this.$router.push('/postsurvey/email');
    },
  },
};
</script>

<style scoped>
.vanilla-e-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-progress-fill: #534AB7;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.vanilla-e-wrap *,
.vanilla-e-wrap *::before,
.vanilla-e-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1rem 1.25rem;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.back-button {
  background: transparent;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 20px;
  color: var(--color-text-secondary);
  line-height: 1;
}

.back-button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.question-counter {
  font-size: 13px;
  color: var(--color-text-secondary);
}

.progress-bar {
  display: flex;
  gap: 4px;
  margin-bottom: 1.5rem;
}

.progress-segment {
  height: 6px;
  border-radius: 3px;
  background: var(--color-bg-muted);
  overflow: hidden;
}

.progress-segment-fill {
  height: 100%;
  background: var(--color-progress-fill);
  border-radius: 3px;
}

.question-block {
  margin-bottom: 1.25rem;
}

.section-label {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0 0 6px;
}

.question-title {
  font-size: 22px;
  font-weight: 500;
  margin: 0 0 8px;
  line-height: 1.3;
}

.question-prompt {
  font-size: 15px;
  color: var(--color-text-secondary);
  margin: 0;
}

.tooltip-button {
  background: transparent;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 8px 12px;
  font-size: 13px;
  color: var(--color-text-secondary);
  cursor: pointer;
  align-self: flex-start;
  margin-bottom: 1.5rem;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.tooltip-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--color-progress-fill);
  color: white;
  font-size: 11px;
  font-weight: 500;
  font-style: italic;
  font-family: Georgia, serif;
  line-height: 1;
}

.tooltip-button:hover {
  background: var(--color-bg-muted);
}

.tooltip-content {
  background: var(--color-bg-muted);
  border-radius: var(--radius-md);
  padding: 12px 14px;
  font-size: 14px;
  color: var(--color-text-secondary);
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.answer-fieldset {
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.answer-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  background: var(--color-bg-card);
  transition: background 0.15s, border-color 0.15s;
}

.answer-option:hover {
  background: var(--color-bg-muted);
}

.answer-option:has(input:checked) {
  border-color: var(--color-progress-fill);
  background: var(--color-bg-muted);
}

.answer-option input[type="radio"] {
  margin: 3px 0 0 0;
  accent-color: var(--color-progress-fill);
  flex-shrink: 0;
}

.answer-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.answer-label {
  font-size: 15px;
  color: var(--color-text-primary);
  line-height: 1.4;
}

.answer-detail {
  font-size: 12px;
  color: var(--color-text-tertiary);
  line-height: 1.4;
}

.footer {
  margin-top: auto;
  padding-top: 1.5rem;
}

.next-button {
  width: 100%;
  padding: 14px;
  background: var(--color-bg-muted);
  color: var(--color-text-tertiary);
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  cursor: not-allowed;
  transition: background 0.15s;
}

.next-button:not(:disabled) {
  background: var(--color-progress-fill);
  color: white;
  border-color: var(--color-progress-fill);
  cursor: pointer;
}

.next-button:not(:disabled):hover {
  opacity: 0.9;
}
</style>
